import React, { useState } from 'react';
import InputMask from 'react-input-mask';

import Input, { InputProps } from './Input';

interface MaskedInputProps extends InputProps {
  mask: string;
  maskChar?: string;
}
const MaskedInput = (props: MaskedInputProps) => {
  const { mask, name, errorContext, label, maskChar = '', onBlur, ...rest } = props;

  const [value, setValue] = useState('');

  return (
    <InputMask
      mask={mask}
      maskChar={maskChar}
      value={value}
      onBlur={onBlur}
      onChange={(e: any) => setValue(e.target.value)}
    >
      {(inputProps: any) => (
        <Input {...inputProps} {...rest} label={label} errorContext={errorContext} name={name} id={name} />
      )}
    </InputMask>
  );
};

export default MaskedInput;
